/** Type de période de tendances */
enum TrendPeriodEnum {
    None = 0,
    /** Période précédante */
    Previous = 1,
    /** Année précédante */
    LastYear,
    /** Année de référence */
    RefYear,
}

export default TrendPeriodEnum;